import {
  DEFAULT_OTP_RESEND_AFTER_SECONDS,
  OTP_ERROR_INCOMPLETE
} from '@/components/OtpEntry/constants'

// Validation
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
export const PHONE_REGEX = /^[6-9]\d{9}$/

// Error messages
export const ERROR_MESSAGES = {
  EMPTY_NAME: 'Please enter your name',
  EMPTY_EMAIL: 'Please enter your email address',
  INVALID_EMAIL: 'Please enter a valid email address',
  EMPTY_MOBILE_NUMBER: 'Please enter your mobile number',
  INVALID_MOBILE_NUMBER: 'Please enter a valid 10-digit mobile number',
  EMPTY_LOAN_SERVICE_PROVIDER: 'Please select loan service provider',
  EMPTY_CATEGORY: 'Please select category',
  EMPTY_SUBCATEGORY: 'Please select subcategory',
  EMPTY_ISSUE_DESCRIPTION: 'Please enter issue description',
  EMPTY_OTP: OTP_ERROR_INCOMPLETE,
  SUBMIT_FAILED: 'Failed to submit complaint. Please try again.'
}

export { OTP_LENGTH } from '@/components/OtpEntry/constants'

// Success messages
export const SUCCESS_MESSAGES = {
  COMPLAINT_SUBMITTED_TITLE: 'Your issue has been recorded.',
  COMPLAINT_SUBMITTED_SUBTITLE: 'We will reply soon on your registered email address/phone number'
}

/** Lodge complaint: email OTP send / resend snackbars */
export const LODGE_OTP_MESSAGES = {
  SENT: 'OTP sent to your email id',
  SEND_FAILED: 'Failed to send OTP',
  RESEND_FAILED: 'Failed to resend OTP'
}

/** Seconds until resend UI from send-OTP API response, or default. */
export const parseOtpResendAfterSeconds = response => {
  const data = response?.data ?? response ?? {}
  const raw = data.can_resend_after_seconds ?? data.can_resend_after ?? data.expires_in_seconds
  const n = Number.parseInt(String(raw), 10)
  return Number.isFinite(n) && n > 0 ? n : DEFAULT_OTP_RESEND_AFTER_SECONDS
}

// Form state shape – single source of truth for initial and reset
export const INITIAL_FORM = {
  loanServiceProvider: '',
  name: '',
  email: '',
  mobileNumber: '',
  category: '',
  subcategory: '',
  issueDescription: ''
}

// Loan service provider options – single array for dropdown (first item = placeholder)
export const LOAN_SERVICE_PROVIDER_OPTIONS = [
  'Select',
  'Kreditbee',
  'Niro',
  'Nira',
  'Go upwards',
  'Smartcoin',
  'Kiwi',
  'Swiggy',
  'Meesho',
  'PayuPayments',
  'FTCash',
  'Bharat Pe',
  'Paytm',
  'Phone Pe',
  'BFDL(Bajaj)',
  'MeeshoPaylater',
  'Moneyview',
  'Gpay',
  'Lazypay',
  'Paysense',
  'Flipkart',
  'Others'
]

// Category with subcategory labels – subcategory options are dynamic by category
export const COMPLAINT_CATEGORIES = [
  {
    label: 'Collections related',
    subCategories: ['Agent Misbehaviour/Harrasment', 'Settlement/Time Extension']
  },
  {
    label: 'Credit Bureau',
    subCategories: [
      'Account ownership dispute',
      'Loan status not updated at bureau',
      'Incorrect details'
    ]
  },
  {
    label: 'Transaction Related',
    subCategories: [
      'Transaction Failed',
      'Unable to perform transaction',
      'Refund Related',
      'Unauthorized transaction'
    ]
  },
  {
    label: 'Repayment',
    subCategories: [
      'Unable to repay',
      'Refund for excess EMI/payment',
      'Re-payment not updated',
      'NACH related'
    ]
  },
  {
    label: 'Account related',
    subCategories: [
      'Loan does not belongs to me',
      'Foreclosure/Closure Related',
      'KYC Related',
      'Disbursal related'
    ]
  },
  {
    label: 'Charges and Fees',
    subCategories: ['Charges waiver']
  },
  {
    label: 'App related',
    subCategories: ['Unable to login/App crash']
  },
  {
    label: 'Others',
    subCategories: ['Others']
  }
]

// Category dropdown options (placeholder first)
export const CATEGORY_OPTIONS = ['Select main category', ...COMPLAINT_CATEGORIES.map(c => c.label)]

/**
 * Subcategory dropdown options for the selected category (placeholder first).
 * @param {string} categoryLabel - selected category label
 * @returns {string[]} options for subcategory dropdown
 */
export const getSubcategoryOptions = categoryLabel => {
  if (!categoryLabel || categoryLabel === 'Select main category') {
    return ['Select sub category']
  }
  const category = COMPLAINT_CATEGORIES.find(m => m.label === categoryLabel)
  if (!category?.subCategories?.length) return ['Select sub category']
  return ['Select sub category', ...category.subCategories]
}
